import { __extends } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-gallery-carousel.css';
var getClassNameList = classNames.bind(styles);
var UitkGalleryCarouselNavdots = /** @class */function (_super) {
  __extends(UitkGalleryCarouselNavdots, _super);
  function UitkGalleryCarouselNavdots() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  UitkGalleryCarouselNavdots.prototype.getdotStyles = function (currentIndex, imagesLengthNumber, padding) {
    // Patterns are a pattern of dots that should be shown depending on how many images there are.
    // the numbers corrolate to the index in styles array
    // ie. 02321 === dot-zero, dot-medium, dot-current, etc.
    var patterns = {
      // 5 === five or more images, 4 === four images, etc.
      5: ['03221', '02321', '12321', '12320', '12230'],
      4: ['3221', '2321', '1232', '1223'],
      3: ['322', '232', '223'],
      2: ['32', '23']
    };
    var styles = ['dot-zero', 'dot-small', 'dot-medium', 'dot-current'];
    var imagesLength = this.props.imagesLength;
    var fiveOrMore = imagesLength >= 5;
    var patternLength = fiveOrMore ? 5 : imagesLength;
    var currentIndexNumber = currentIndex;
    if (fiveOrMore && currentIndexNumber >= 2 && currentIndexNumber < imagesLengthNumber - 2) {
      currentIndexNumber = 2;
    } else if (fiveOrMore && currentIndexNumber === imagesLengthNumber - 2) {
      currentIndexNumber = 3;
    } else if (fiveOrMore && currentIndexNumber === imagesLengthNumber - 1) {
      currentIndexNumber = 4;
    }
    var currentPattern = patterns[patternLength][currentIndexNumber].split('');
    // Push extra zeros so that there are dots to be grown or shrunk at the edges
    if (padding === 'left') {
      currentPattern.unshift('0', '0');
    } else if (padding === 'right') {
      currentPattern.push('0', '0');
    } else if (fiveOrMore) {
      currentPattern.push('0');
      currentPattern.unshift('0');
    }
    var dotStyles = currentPattern.map(function (x) {
      return styles[x];
    });
    return dotStyles;
  };
  UitkGalleryCarouselNavdots.prototype.getDotList = function (currentIndex, imagesLength, padding) {
    var elementList = [];
    if (imagesLength > 1) {
      var styles = this.getdotStyles(currentIndex, imagesLength, padding);
      elementList = styles.map(function (x, index) {
        return React.createElement("div", {
          key: index,
          className: getClassNameList('uitk-gallery-carousel-dot-wrap')
        }, React.createElement("div", {
          className: getClassNameList('uitk-gallery-carousel-dot', x)
        }));
      });
    }
    return elementList;
  };
  UitkGalleryCarouselNavdots.prototype.render = function () {
    var _a = this.props,
      animation = _a.animation,
      currentIndex = _a.currentIndex,
      imagesLength = _a.imagesLength;
    if (imagesLength <= 1) {
      return null;
    }
    var animationstyles = animation;
    var dotsShown = this.getDotList(currentIndex, imagesLength);
    if (animation && animation !== '') {
      if (animation === 'uitk-gallery-carousel-next') {
        dotsShown = this.getDotList(currentIndex + 1, imagesLength);
      }
      if (animation === 'uitk-gallery-carousel-prev') {
        dotsShown = this.getDotList(currentIndex - 1, imagesLength);
      }
      if (animation === 'uitk-gallery-carousel-next' && currentIndex >= 1 && currentIndex < imagesLength - 2 && imagesLength >= 5) {
        animationstyles += ' uitk-gallery-carousel-midpoint';
        dotsShown = this.getDotList(currentIndex + 1, imagesLength, 'left');
      }
      if (animation === 'uitk-gallery-carousel-prev' && currentIndex > 1 && currentIndex <= imagesLength - 2 && imagesLength >= 5) {
        animationstyles += ' uitk-gallery-carousel-midpoint';
        dotsShown = this.getDotList(currentIndex - 1, imagesLength, 'right');
      }
    }
    return React.createElement("div", {
      className: getClassNameList("uitk-gallery-carousel-navi-dots", animationstyles)
    }, dotsShown);
  };
  UitkGalleryCarouselNavdots.displayName = 'UitkGalleryCarouselNavdots';
  return UitkGalleryCarouselNavdots;
}(React.PureComponent);
export { UitkGalleryCarouselNavdots };